import api from './api';

export interface ContentExportData {
  client_id?: string;
  media_file_id?: string;
  content_type: 'media_download' | 'ai_generation' | 'post_export';
  export_format: string;
  export_size?: string;
  file_name: string;
  file_size?: number;
}

export interface ContentExport {
  id: string;
  user_id: string;
  client_id?: string;
  media_file_id?: string;
  content_type: string;
  export_format: string;
  export_size?: string;
  file_name: string;
  file_size?: number;
  created_at: string;
}

class ContentExportService {
  async trackExport(exportData: ContentExportData): Promise<ContentExport> {
    const response = await api.post('/content-exports/', exportData);
    return response.data;
  }

  async getExportStats() {
    const response = await api.get('/content-exports/stats');
    return response.data;
  }
}

export default new ContentExportService();